import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  hasSearchQuery: boolean
}

// No call to action when the list is empty: creating a template is not supported by the admin
// API yet (see the design doc's §2.3), so "Add one to get started" would be a dead end.
const EmptyOnboardingTemplatesComponent = ({ hasSearchQuery }: Props) => {
  return (
    <div
      data-testid="onboarding-templates-list-empty"
      css={tw`flex h-full w-full flex-col items-center justify-center gap-1`}
    >
      <Typography variant="subtitle1">No onboarding templates found</Typography>
      <Typography variant="body2" css={tw`text-shades-500`}>
        {hasSearchQuery ? 'Try a different search.' : 'This customer has no templates yet.'}
      </Typography>
    </div>
  )
}

export const EmptyOnboardingTemplates = memo(EmptyOnboardingTemplatesComponent)
